module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-600italic.2be3f441.eot";